module.exports = __webpack_public_path__ + "static/media/index-ad-img4.31ce906f.png";